import {SORespPerson} from '../../core/person/so-resp-person';
import {PersonCore} from './person.core';
import {CEBase} from 'lionheartland';
import {EntityViewSpecProtocol} from 'lionheartland';
import { CommanderApp } from "../../land-app";
import {PutPersonFormFields} from './put-person-form-fields';
import { CEPersonAttributes } from './ce-person-attributes'


export class CEPersonBase extends CEBase {

    public details: CEPersonAttributes;
    public fromFields: PutPersonFormFields = new PutPersonFormFields();

    constructor(
        public parentEntityViewSpec: EntityViewSpecProtocol,
        public core: PersonCore,
        public entity: SORespPerson,
        public app: CommanderApp,
    ) {
        super(
            parentEntityViewSpec, core, entity, app,
        )
        this.details = new CEPersonAttributes(
            parentEntityViewSpec,
            entity,
            app,
            this.fromFields
        );
        this.setAttributes();
        this.sortAttributes();
    }

    setAttributes() {

        this.attributes = []
        this.attributes.push(this.details.name)
        this.attributes.push(this.details.description)
        this.attributes.push(this.details.relation)
        this.attributes.push(this.details.assignedProjects)
        this.attributes.push(this.details.user)

    }
}